export default {
  header: 'Vi kunne ikke indlæse din ordre',
  text: 'Noget gik galt, mens vi gjorde din ordre klar. Din kurv er gemt – prøv igen.',
  retry: 'Prøv igen',
  address_header: 'Vi har brug for din leveringsadresse',
  address_text: 'Vi kan ikke beregne din total, før vi ved, hvor der skal leveres. Din kurv er gemt.',
  address_action: 'Tilføj leveringsadresse',
  back_checkout: 'Tilbage til din ordre',
  back_basket: 'Tilbage til din kurv',
};
